import { render, staticRenderFns } from "./NumResults.vue?vue&type=template&id=e07a9e54&"
import script from "./NumResults.vue?vue&type=script&lang=js&"
export * from "./NumResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports